var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.429688,
    width: 33.1416,
    height: 34.1959,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_45_19",
    transform: "matrix(0.0111111 0 0 0.0107685 0 0.0154154)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_45_19",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACSUlEQVR4nO3csWoVQRSH8VOZEBDRNlY2CoEgdr5BuhR5BUujlfgI1tZaBcRXsEtIEU1lrER7W0US0MpPRhZuhAmZvTNzZnT+vz7sme/O3ewGMmYiIiIiIiIiImLAKvAYOAbO+H+dAe+AR8CK60cP3AQ+MJ6TsHbPnTxi5POx6+/s6XYxul2P0OGePLq3HqFPW6+yA6ceoQVQaCcK7UShnSi0E4V2otALX4E94AFwF1gH1qYnp+vADeAWsAFsAa+ZQaH5E/gJcHXmY2v4GYVO9Am4s+T7gUIn+gxcW/YrrdBpfgL3lo2s0Ome50RW6DS/gNsKXd9hbmTt6DTPFNrHduKOvQ+8mZ6zs5X4cC8buDcbCTOHN8MfJS86Yuj1hJlflb7oiKHXEmb+WPqiw4W2tJm/tbjuiKGLU+iI8pkVOkqhC4inVejiEUsBXnY1G47MEXDQ1Wz1sjZYzN/r+sIMHgO5MSfhpWf6c2s/s9XL2mAxizVtMpPHUG7MCbDT3Wx1kjZazGJNT5nJYyg35gR40d1sdZI2WsxiTfvM5DFUV6zRzAododAFxMIqdAUK7cS0oxU6C52xRjPnVVToZAodkZ5PoS8UC6vQFSi0E9OOVugsdMYazZxXUaGTKXREej6FvlAsrEJXoNBOTDtaobPQGWs0c17Ff/A4NmsT+vtwBwxam9AuBwyGU2dHD/3QI/TKdBDqqKHfA1eqhz53rHEXsS1t3pKRL/0H0ho7ezfcr1r+grS0WXOEtR2F24XbThYRERERERERsb79Bvmh4UzwAuRsAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.7a6e3db4652075315b51851bbf17ebb3.svg";
export { ForwardRef as ReactComponent };